module.exports = __webpack_public_path__ + "img/10015.1bdbe272.jpg";